import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController, NavParams } from 'ionic-angular';
import { Store } from '@ngrx/store';
import * as util from 'ethereumjs-util';

//import { AppContract } from '../../app/app.contract';
import { ContractsService } from '../../app/app.contract.service';
import { AppState } from '../../app/app.reducer';
import { AppUtilities } from '../../app/app.utilities';
import { ConfirmationPage } from '../confirmation/confirmation';
import { NodeService } from '../../services/node.service';
import { Token, Transaction, Wallet } from '../../app/app.models';
import { TokensFetchAction } from '../../app/app.actions';

import { HomePage } from '../home/home';

@Component({
  selector: 'page-tokensend',
  templateUrl: 'tokensend.html'
})
export class TokensendPage {
  public formData: FormGroup;
  public token$: Token;
  public wallet$: Wallet;

  constructor(
    private contractService: ContractsService,
    public formBuilder: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public nodeService: NodeService,
    public store: Store<AppState>,
    public utilities: AppUtilities
  ) {
    this.token$ = navParams.data;

    this.store.select('wallet').subscribe((wallet: Wallet) => {
      this.wallet$ = wallet;
    });

    this.formData = this.formBuilder.group({
      address: ['', Validators.required]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TokensendPage');
  }

  cancel() {
    this.navCtrl.pop();
  }

  onSubmit(formData: FormGroup) {}

  isValidAddress(address: string): boolean {
    return util.isValidAddress(address) && address !== this.wallet$.address;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tokensend/tokensend.ts